import { render, staticRenderFns } from "./JSelectStudent.vue?vue&type=template&id=11234fac&scoped=true"
import script from "./JSelectStudent.vue?vue&type=script&lang=js"
export * from "./JSelectStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11234fac",
  null
  
)

export default component.exports